import useOnLoad from '~/routes/use-on-load';
import useCountryBackgroundTask from './useCountryBackgroundTask';
import useRefundsBackgroundTask from './useRefundsBackgroundTask';
import useImportBackgroundTask from './useImportBackgroundTask';
import useSocketsBackgroundTask from './useSocketsBackgroundTask';
import useSocketBackupBackgroundTask from './useSocketBackupBackgroundTask';

const SmartSendBackgroundTasks: React.FC = () => {
  useCountryBackgroundTask();
  useRefundsBackgroundTask();
  useImportBackgroundTask();
  useSocketsBackgroundTask();
  useSocketBackupBackgroundTask();

  // App Start
  useOnLoad(() => {
    console.log('SmartSendBackgroundTasks: Loaded');
  });

  return null;
};

export default SmartSendBackgroundTasks;
